module.exports = __webpack_public_path__ + "img/womanlogo.982c0ae3.png";